import React, { useEffect } from 'react';
import adapterIntegrationApi from '../../../api/adapterIntegration.api';
import { uiSchemaProperties } from '../../../shared/enums/uiSchemaProperties';
import { searchFieldById } from '../../../shared/utils/objectUtils';

const useUniversityIntegration = (uiSchema, id, registry, formContext) => {
  const triggerField =
    uiSchema && uiSchema[uiSchemaProperties.UI_AUTOCOMPLETE_TRIGGER]
      ? uiSchema[uiSchemaProperties.UI_AUTOCOMPLETE_TRIGGER]
      : [];
  const widgetTrigger =
    uiSchema && uiSchema[uiSchemaProperties.UI_WIDGET_TRIGGER] ? uiSchema[uiSchemaProperties.UI_WIDGET_TRIGGER] : [];
  const widgetTriggerMapper = widgetTrigger?.mapper;
  const widgetTriggerBase = widgetTrigger?.base;
  const widgetTriggerTarget = widgetTrigger?.target;
  const widgetIntegrationService = widgetTrigger?.integrationService;
  const rootId = id?.replace(triggerField?.base, '');
  const targetFieldVal = searchFieldById(formContext, `${rootId}${triggerField.target}`);

  const [integrationEnumOptions, setIntegrationEnumOptions] = React.useState(null);
  const [integrationData, setIntegrationData] = React.useState(null);
  let tmt = null;

  useEffect(() => {
    const readIntegrationService = async () => {
      const result = await adapterIntegrationApi.get(widgetIntegrationService);
      setIntegrationData(result);
    };
    if (widgetIntegrationService) {
      readIntegrationService();
    }
  }, []);

  useEffect(() => {
    if (widgetIntegrationService && targetFieldVal && integrationData?.length > 0) {
      const data = integrationData
        ?.filter(item => item.mainDetails.type === targetFieldVal)
        .map(obj => ({
          label: obj.mainDetails.name,
          value: obj.mainDetails.name,
        }));
      setIntegrationEnumOptions(data?.length > 0 ? data : null);
    }
  }, [targetFieldVal, integrationData]);

  const checkIntegrationResult = (val) => {
    const mapperArr = widgetTriggerMapper.split('.');
    const widgetTriggerBaseArr = widgetTriggerBase.split('.');
    let result = null;
    if (!integrationData || integrationData.length === 0) {
      return null;
    }
    integrationData.forEach((obj) => {
      let tempObj = Object.create(obj);
      let tempBase = Object.create(obj);
      mapperArr.forEach((key) => {
        tempObj = tempObj[key];
      });
      if (tempObj === val) {
        widgetTriggerBaseArr.forEach((i) => {
          tempBase = tempBase[i];
        });
        result = tempBase;
      }
    });
    return result;
  };

  const callIntegrationFn = async (value) => {
    clearTimeout(tmt);
    tmt = setTimeout(async () => {
      const getData = checkIntegrationResult(value);
      const $ids = id.split('_').slice(1, -1);
      await registry.setFormData(getData, `${$ids.join('.')}.${widgetTriggerTarget}`);
    }, 500);
  };

  return {
    callIntegrationFn,
    widgetIntegrationService,
    integrationEnumOptions,
  };
};

export default useUniversityIntegration;
